// extracted by mini-css-extract-plugin
export default {"addNewAccountBtnContainer":"AddNewAccount_addNewAccountBtnContainer__ijcqZ"};